import Vue from 'vue'

export default {
    list() {
        return Vue.axios.get(`/couriers`, {params})
    },
    listCouriers() {
        return Vue.axios.get(`/couriers/list`)
    },
    importCouriers() {
        return Vue.axios.get(`/couriers/import`)
    },
    updateCourier(id, data) {
        return Vue.axios.post(`/couriers/${id}`, data)
    },
    listActiveCoordinated() {
        return Vue.axios.get(`/couriers/coordinates`)
    },
}
